export const VERTICALS = {
    agritourism: {
        slug: 'agritourism',
        index: '01',
        eyebrow: 'Vertical One',
        title: 'Agritourism & Rural Experiences',
        tagline: 'Reconnect with rural India. Return with stories, not souvenirs.',
        summary:
            'Immersive experiences that honour the land and the people who tend it — farm stays, village immersions, craft trails and corporate offsites designed with the community, for the community.',
        hero: 'https://images.pexels.com/photos/36666146/pexels-photo-36666146.jpeg',
        gallery: [
            'https://images.pexels.com/photos/36832365/pexels-photo-36832365.jpeg',
            'https://images.pexels.com/photos/32277759/pexels-photo-32277759.jpeg',
            'https://images.unsplash.com/photo-1722925407220-b22e1ced9ee9',
        ],
        offerings: [
            'Curated farm stays with host families',
            'Village immersion programs (2–5 days)',
            'Craft trails: weavers, potters, block-printers',
            'Heritage & food walks led by locals',
            'Corporate offsites designed for reflection',
            'Regenerative tourism itineraries',
        ],
        metrics: [
            { label: 'Host families onboarded', value: '120+' },
            { label: 'Villages partnered', value: '42' },
            { label: 'Avg. household income lift', value: '2.4×' },
        ],
    },
    gatherings: {
        slug: 'gatherings',
        index: '02',
        eyebrow: 'Vertical Two',
        title: 'Community Gatherings & Fundraising Events',
        tagline: 'Small rooms. Long tables. Ideas that travel further than the evening.',
        summary:
            'Intimate dinners, supper clubs, fireside chats and impact salons that gather changemakers around meaningful conversations — every seat contributes to a rural livelihood.',
        hero: 'https://images.unsplash.com/photo-1595433306946-233f47e4af3a',
        gallery: [
            'https://images.unsplash.com/photo-1519744792095-2f2205e87b6f',
            'https://images.unsplash.com/photo-1530103862676-de8c9debad1d',
            'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf',
        ],
        offerings: [
            'Founder dinners & CEO tables',
            'Supper clubs and community lunches',
            'Fireside chats with makers & scholars',
            '“Meet a Professor” evenings',
            'Career counselling & mentoring salons',
            'Curated networking with purpose',
        ],
        metrics: [
            { label: 'Events hosted', value: '76' },
            { label: 'Funds channelled to programs', value: '84%' },
            { label: 'Repeat attendees', value: '63%' },
        ],
    },
    volunteering: {
        slug: 'volunteering',
        index: '03',
        eyebrow: 'Vertical Three',
        title: 'Volunteering & Skill-Based Giving',
        tagline: 'Bring your craft. Leave behind capacity.',
        summary:
            'Professionals, students and companies contribute the skills that rural entrepreneurs actually need — from design and marketing to legal, finance and product photography.',
        hero: 'https://images.unsplash.com/photo-1759738098462-90ffac98c554',
        gallery: [
            'https://images.pexels.com/photos/14120649/pexels-photo-14120649.jpeg',
            'https://images.unsplash.com/photo-1719593622853-c625441bc4e0',
            'https://images.pexels.com/photos/20242195/pexels-photo-20242195.jpeg',
        ],
        offerings: [
            'Market access for Banarasi weavers',
            'Adopt-a-village fellowships',
            'Digital & financial literacy workshops',
            'Entrepreneurship mentoring',
            'Design, marketing & photography support',
            'Legal, financial & strategy advisory',
        ],
        metrics: [
            { label: 'Volunteer hours', value: '18,400' },
            { label: 'Skilled mentors', value: '540+' },
            { label: 'Enterprises supported', value: '96' },
        ],
    },
    campaigns: {
        slug: 'campaigns',
        index: '04',
        eyebrow: 'Vertical Four',
        title: 'Impact Campaigns',
        tagline: 'Purpose, woven into the way your business shows up.',
        summary:
            'We help organisations embed social purpose into everyday decisions — from sustainable events and conscious corporate gifting to artisan-led installations and fabric packaging.',
        hero: 'https://images.pexels.com/photos/20242195/pexels-photo-20242195.jpeg',
        gallery: [
            'https://images.unsplash.com/photo-1519741497674-611481863552',
            'https://images.unsplash.com/photo-1610701596007-11502861dcfa',
            'https://images.unsplash.com/photo-1512909006721-3d6018887383',
        ],
        offerings: [
            'Sustainable corporate events & weddings',
            'Conscious corporate gifting collections',
            'Sustainable décor & office styling',
            'Circular fabric gifting (zero single-use)',
            'Artisan-led large-scale installations',
            'CSR campaigns with measurable outcomes',
        ],
        metrics: [
            { label: 'kg single-use plastic avoided', value: '12,500' },
            { label: 'Artisan hours commissioned', value: '38,000' },
            { label: 'Brand partners', value: '48' },
        ],
    },
};

export const VERTICAL_ORDER = ['agritourism', 'gatherings', 'volunteering', 'campaigns'];
